import { Text } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { FormField } from '../../../../components/FormField'
import { Icon } from '../../../../components/Icon'
import { SearchableSelect } from '../../../../components/Select'
import { Tooltip } from '../../../../components/Tooltip'
import { IEventForm } from './eventFormShared'

interface IProps {
  form: IEventForm
  setForm: Dispatch<SetStateAction<IEventForm>>
  fieldErrors: Record<string, string[]>
  saving: boolean
  activeCampaignLists: { id: string; name: string }[]
}

export function MarketingTab({ form, setForm, fieldErrors, saving, activeCampaignLists }: IProps) {
  const listOptions = activeCampaignLists.map((list) => ({ value: list.id, label: list.name }))

  return (
    <>
      <Text variant="caption" mb={4}>
        Listas do Active Campaign em que os contatos serão inscritos. Opcional.
      </Text>

      <FormField
        label={
          <>
            Listas AC Leads
            <Tooltip label="Se nenhuma lista for selecionada, o comprador não é sincronizado no Active Campaign quando clica em 'Comprar ingressos' na página do evento — a tag iniciou-compra-evento não é aplicada.">
              <Icon name="lni lni-information" size="sm" color="gray.400" cursor="help" ml={1.5} />
            </Tooltip>
          </>
        }
        error={fieldErrors['active_campaign_lead_lists']}
        helperText='Apenas o comprador entra nessas listas, ao clicar em "Comprar ingressos" (antes do checkout).'
        mb={5}
      >
        <SearchableSelect
          isMulti
          options={listOptions}
          value={form.active_campaign_lead_lists}
          onChange={(lists) => setForm({ ...form, active_campaign_lead_lists: lists })}
          placeholder="Selecione uma ou mais listas"
          entity="lista"
          feminine
          isDisabled={saving}
        />
      </FormField>

      <FormField
        label={
          <>
            Listas AC Compradores
            <Tooltip label="Se nenhuma lista for selecionada, o comprador não é sincronizado no Active Campaign quando o pagamento é confirmado (ou na inscrição, se o evento for gratuito) — a tag comprou-evento não é aplicada.">
              <Icon name="lni lni-information" size="sm" color="gray.400" cursor="help" ml={1.5} />
            </Tooltip>
          </>
        }
        error={fieldErrors['active_campaign_buyer_lists']}
        helperText="Apenas o comprador entra nessas listas quando o pagamento é efetivado."
      >
        <SearchableSelect
          isMulti
          options={listOptions}
          value={form.active_campaign_buyer_lists}
          onChange={(lists) => setForm({ ...form, active_campaign_buyer_lists: lists })}
          placeholder="Selecione uma ou mais listas"
          entity="lista"
          feminine
          isDisabled={saving}
        />
      </FormField>
    </>
  )
}
